<script>
  import { format as d3Format } from "d3-format";
  import { interpolate } from "d3-interpolate";
  import { timer as d3Timer } from "d3-timer";

  export let number = null;
  export let format = ",.2f";
  export let duration = 300;

  let displayNumber = 0;
  $: cachedNumber = 0;
  $: formatFunction = typeof format == "string" ? d3Format(format) : format;

  const startInterpolate = () => {
    const interpolationFunction = interpolate(cachedNumber, number);

    const timer = d3Timer(timeElapsed => {
      const t = timeElapsed / duration;

      displayNumber = interpolationFunction(t);

      if (t >= 1) {
        timer.stop();
        displayNumber = number;
        cachedNumber = number;
      }
    });
  };

  $: number, startInterpolate();
</script>

<span class="c">
  {Number.isFinite(+displayNumber) ? formatFunction(displayNumber) : '-'}
</span>

<style>
  .c {
    /* font-family: "Inter", sans-serif; */
    /* font-feature-settings: "tnum", "zero"; */
    /* font-weight: 800; */
  }
</style>
